export default "/img/PL.1fcb6c08f05c155b89fbb56ef04a9a91.png";